import FormattedPrice from './FormattedPrice';

export default FormattedPrice;
